// frontend/src/pages/subscribe/Subscribe.jsx

import React, { useState, useContext, useEffect } from "react";
import "./subscribe.css";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import Header from "../../components/header/Header";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCircleXmark, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function Subscribe() {
  const { user, token, dispatch } = useContext(Context);
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [subscription, setSubscription] = useState({});

  const [articleCount, setArticleCount] = useState(null);
  const [writerCount, setWriterCount] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch({ type: "LOGOUT" });
  };

  useEffect(() => {
    const getSubscription = async () => {
      if (!user || !user._id) return;
      try {
        const res = await axios.get(`/users/id/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.status !== 200) {
          toast.info(res.data.msg);
        }
        const planType = res.data.subscription.plan;
        const subscriptionId = res.data.subscription.subscriptionId;
        setSubscription({ plan: planType, subscriptionId: subscriptionId });
      } catch (err) {
        console.error("Error getting Subscription! " + err);
        toast.error("Error Fetching Subscription Details!");
      }
    };

    const getStats = async () => {
      try {
        const articleRes = await axios.get("/stats/articles/count");
        const writerRes = await axios.get("/stats/writers/count");
        setArticleCount(articleRes.data.count);
        setWriterCount(writerRes.data.count);
      } catch (err) {
        console.error("Failed to fetch article/writer counts", err);
      }
    };

    if (user) {
      getSubscription();
    }

    getStats();
  }, [user]);


  const handleSubscribe = async (plan) => {
    if (!user) {
      toast.info("You Need To Login First!");
      return navigate("/login");
    }

    try {
      const user_Id = user?._id;

      if (!user_Id) {
        toast.error("Invalid userId. Please try again.");
        return;
      }

      if (!["monthly", "annually"].includes(plan)) {
        toast.error("Invalid plan. Please try again.");
        return;
      }

      const isSubscribed = subscription?.plan && subscription.plan !== "plan";

      if (isSubscribed) {
        toast.info("Manage your active subscription in your profile!");
        return;
      }

      console.log("Plan:", plan);

      const res = await axios.post(
        "/stripe/create-checkout-session",
        { plan, userId: user_Id },
        { headers: {'Authorization': `Bearer ${token}` } }
      );

      if (res.status !== 200) {
        toast.info(res.data.msg || "Unexpected response from server.");
        return;
      }

      const session = res.data;
      if (!session.url) {
        toast.error("Invalid checkout session response.");
        return;
      }

      window.location.href = session.url;
    } catch (error) {
      console.error("Error creating checkout session:", error.response?.data || error.message);
      toast.error(error.response?.data?.error || "Checkout failed. Try again.");
    }
  };

  return (
    <>
      <Header />
      <div className="center-text">
        <h1 style={{ fontSize: "40px", paddingBottom:"20px" }}>
          Your Next Great Read Starts Here!
        </h1>
      </div>

      <div className="center-text">
        {articleCount !== null && writerCount !== null ? (
          <p style={{ fontSize: "25px", marginBottom: "5rem" }}>
            Choose a plan to unlock {(Math.floor(articleCount / 50) * 50).toLocaleString()}+ original, ad-free articles crafted by {writerCount} passionate writers — and counting.
          </p>
        ) : (
          <p style={{ fontSize: "25px", marginBottom: "5rem" }}>
            Choose a plan to unlock our growing library of original, ad-free articles crafted by a passionate community of writers.
          </p>
        )}
      </div>

      <section className="card-container-subscribe">
        <div className="card-subscribe">
          

          <div style={{ paddingLeft: "25px" }}>

          <h2
            style={{
              fontSize: "25px",
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            MONTHLY PLAN
          </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                fontSize: "18px",
              }}
            >
              Full access with flexibility — Upgrade to annual anytime.
            </p>
            <p style={{ fontSize: "40px", fontWeight: 700 }}>
              $10
              <span style={{ fontSize: "20px", fontWeight: 400 }}>&nbsp;CAD</span>
            </p>
            <p
              style={{
                fontSize: "20px",
                fontWeight: 400,
                marginBottom: "20px",
              }}
            >
              /Month
            </p>
            <p style={{ fontSize: "20px", fontWeight: 400, marginBottom: "30px" }}>Only $2.50 per week</p>
          </div>

          <div style={{ display: "flex" }}>
            {/* <a href="/payment"> */}
            <button
              style={{
                height: "63px",
                width: "277px",
                fontSize: "28px",
                fontWeight: "700",
              }}
              onClick={() => handleSubscribe("monthly")}
            >
              Choose Monthly
            </button>
            {/* </a> */}
          </div>
          <div>
            <p
              style={{
                marginTop: "6px",
                marginBottom: "10px",
                fontSize: "14px",
                fontWeight: 400,
                opacity: 0.9,
                textAlign: "center",
              }}
            >
              <span>Promo codes apply to annual only.</span>
            </p>
          </div>
        </div>

        <div className="card-subscribe">
          
          <div style={{ paddingLeft: "25px", position: "relative" }}>
          <div className="card-free-months" style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-90px",
                    width: "219px",
                    height: "61px",
                    backgroundColor: "#FAFAFA",
                    color: "#272635",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "700",
                    borderRadius: "10px",
                    fontSize:"24px",
                    fontWeight:"700",
                    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.12)",
                    }}>
                    3 MONTHS FREE!
                    </div>   
          <h2
            style={{
              fontSize: "25px",
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            ANNUAL PLAN
          </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                fontSize: "18px",
              }}
            >
              Best value — Pay once a year and enjoy full access all year long!
            </p>
            <p style={{ fontSize: "40px", fontWeight: 700 }}>
              $90
              <span style={{ fontSize: "20px", fontWeight: 400 }}>&nbsp;CAD</span>
            </p>
            <p
              style={{
                fontSize: "20px",
                fontWeight: 400,
                marginBottom: "20px",
              }}
            >
              /Year
            </p>
            <p style={{ fontSize: "20px", fontWeight: 400, marginBottom: "30px" }}>Only $1.75 per week</p>
          </div>
          <div style={{ display: "flex" }}>
            {/* <a href="/payment"> */}
            <button
              style={{
                height: "63px",
                width: "277px",
                fontSize: "28px",
                fontWeight: "700",
              }}
              onClick={() => handleSubscribe("annually")}
            >
              Choose Annual
            </button>
            {/* </a> */}
          </div>
          <div>
            <p
              style={{
                marginTop: "6px",
                marginBottom: "10px",
                fontSize: "14px",
                fontWeight: 400,
                opacity: 0.9,
                textAlign: "center",
              }}
            >
              <span>Have a promo code?</span>{" "}
              <span style={{ fontWeight: 700 }}>Save $20</span>{" "}
              <span>on your first year.</span>{" "}
              <span>Applied at checkout.</span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

function SearchBar({ onClose }) {
  return (
    <div className="search-overlay">
      <div className="search-bar-container">
        <form className="searchForm1-search">
          <div className="input-container-search">
            <input
              type="text"
              placeholder="Entering..."
              style={{
                width: "679px",
                height: "52px",
                borderRadius: "10px",
                border: "0.5px solid lightgray",
                paddingRight: "40px",
                position: "relative", // changed from absolute to relative
              }}
              onChange={(e) => {
                // handle search input
              }}
            />
            <button className="searchSubmit1" type="submit" style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                color: "black"
              }}>
              <FontAwesomeIcon icon={faSearch} />
            </button>
            
          </div>
          <button className="close-search" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
        </form>
        
      </div>
    </div>
  );
}
